import { FileText } from 'lucide-react';
import { cn } from '@/utils/cn';
import { DIFF_BG, DIFF_SIGN, DIFF_SIGN_COLOR } from './constants';
import type { DiffFileRow } from './types';

interface FilesDiffProps {
  rows: DiffFileRow[];
  onlyChanges: boolean;
}

export const FilesDiff = ({ rows, onlyChanges }: FilesDiffProps) => {
  const visible = onlyChanges ? rows.filter((row) => row.status !== 'unchanged') : rows;
  return (
    <div className="divide-y divide-neutral-100">
      {visible.map((row) => (
        <div
          key={row.id}
          data-diff-change={row.status !== 'unchanged' || undefined}
          className={cn('flex items-center gap-3 px-3 py-2', DIFF_BG[row.status])}
        >
          <span
            className={cn('w-4 text-center font-mono text-[12px]', DIFF_SIGN_COLOR[row.status])}
          >
            {DIFF_SIGN[row.status]}
          </span>
          <FileText
            size={14}
            className={cn(
              row.status === 'added'
                ? 'text-emerald-600'
                : row.status === 'removed'
                ? 'text-red-500'
                : 'text-neutral-400'
            )}
          />
          <div className="min-w-0 flex-1">
            <div
              className={cn(
                'text-[13px] truncate',
                row.status === 'removed' ? 'text-neutral-500 line-through' : 'text-neutral-900'
              )}
            >
              {row.name}
            </div>
            <div className="text-[11px] text-neutral-500">{row.meta}</div>
          </div>
          {row.status !== 'removed' && row.url && (
            <a
              href={row.url}
              target="_blank"
              rel="noopener noreferrer"
              className="h-6 px-2 inline-flex items-center rounded border border-neutral-200 bg-white text-[11px] text-neutral-600 hover:bg-neutral-50"
            >
              Otevřít
            </a>
          )}
        </div>
      ))}
    </div>
  );
};
